/**
 * PURPOSE: Canvas drawing functions for each annotation tool (freehand, arrow, circle, text)
 */
import type { Annotation } from './types'

export function drawAnnotation(ctx: CanvasRenderingContext2D, annotation: Annotation) {
  ctx.strokeStyle = annotation.color
  ctx.fillStyle = annotation.color
  ctx.lineWidth = annotation.lineWidth
  ctx.lineCap = 'round'
  ctx.lineJoin = 'round'

  switch (annotation.tool) {
    case 'draw':
      if (annotation.points && annotation.points.length > 1) {
        ctx.beginPath()
        ctx.moveTo(annotation.points[0].x, annotation.points[0].y)
        for (let i = 1; i < annotation.points.length; i++) {
          ctx.lineTo(annotation.points[i].x, annotation.points[i].y)
        }
        ctx.stroke()
      }
      break

    case 'arrow':
      if (annotation.start && annotation.end) {
        const dx = annotation.end.x - annotation.start.x
        const dy = annotation.end.y - annotation.start.y
        const angle = Math.atan2(dy, dx)
        const headLength = Math.max(15, Math.sqrt(dx * dx + dy * dy) * 0.15)
        ctx.beginPath()
        ctx.moveTo(annotation.start.x, annotation.start.y)
        ctx.lineTo(annotation.end.x, annotation.end.y)
        ctx.stroke()
        ctx.beginPath()
        ctx.moveTo(annotation.end.x, annotation.end.y)
        ctx.lineTo(annotation.end.x - headLength * Math.cos(angle - Math.PI / 6), annotation.end.y - headLength * Math.sin(angle - Math.PI / 6))
        ctx.lineTo(annotation.end.x - headLength * Math.cos(angle + Math.PI / 6), annotation.end.y - headLength * Math.sin(angle + Math.PI / 6))
        ctx.closePath()
        ctx.fill()
      }
      break

    case 'circle':
      if (annotation.start && annotation.end) {
        const rx = Math.abs(annotation.end.x - annotation.start.x) / 2
        const ry = Math.abs(annotation.end.y - annotation.start.y) / 2
        const cx = (annotation.start.x + annotation.end.x) / 2
        const cy = (annotation.start.y + annotation.end.y) / 2
        ctx.beginPath()
        ctx.ellipse(cx, cy, rx, ry, 0, 0, 2 * Math.PI)
        ctx.stroke()
      }
      break

    case 'text':
      if (annotation.text && annotation.position) {
        const fontSize = Math.max(16, annotation.lineWidth * 5)
        ctx.font = `bold ${fontSize}px -apple-system, BlinkMacSystemFont, sans-serif`
        const metrics = ctx.measureText(annotation.text)
        const textHeight = fontSize * 1.2
        ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'
        ctx.fillRect(annotation.position.x - 4, annotation.position.y - textHeight + 4, metrics.width + 8, textHeight + 4)
        ctx.fillStyle = annotation.color
        ctx.fillText(annotation.text, annotation.position.x, annotation.position.y)
      }
      break
  }
}
